import React, { PureComponent } from 'react';

import { trackEvent } from './services/events-tracker-service';

import Alert from './components/alert';

export default class AppError extends PureComponent {
    handleReloadClick = event => {
        event.preventDefault();
        window.location.reload();
    }

    componentDidMount() {
        trackEvent('ERROR.DISPLAY', {
            error: this.props.error,
            info: this.props.info
        });
    }

    render() {
        return (
            <div className="app-hard-alerts">
                <Alert type="error" icon={<span role="img" aria-label="mechanic">👨‍🔧</span>}>
                    We're undergoing maintenance and will be back up shortly. <a href="/dashboard" onClick={this.handleReloadClick}>Refresh Page</a> or <a href="/#action=messageUs">Contact us</a>
                </Alert>
            </div>
        )
    }
}
